<form [formGroup]="editpTicketForm">


    <mat-form-field class="input-group">
        <mat-label>User name</mat-label>
        <input matInput formControlName="pct_user" [value]="pTicket.pct_user">
    </mat-form-field>




    <mat-form-field class="input-group">
        <mat-label>Response name</mat-label>
        <input matInput formControlName="pct_responsename" [value]="pTicket.pct_responsename">
    </mat-form-field>

    <mat-form-field class="input-group">
        <mat-label>Company</mat-label>
        <input matInput [matAutocomplete]="countryAuto" formControlName="pct_company" [value]="pTicket.pct_company">

        <mat-autocomplete #countryAuto="matAutocomplete" (optionSelected)="onCompanySelected($event)">
            <mat-option *ngIf="isLoadingCompanyRecommendations" disabled>...Loading</mat-option>
            <div *ngIf="!isLoadingCompanyRecommendations">
                <mat-option *ngFor="let entry of companyRecommendations" [value]="entry">
                    <div class="option-primary">{{ entry.pct_company }}</div>
                    <div class="option-secondary">
                        {{ entry.pct_countrycode }}
                    </div>
                </mat-option>
            </div>
        </mat-autocomplete>
    </mat-form-field>

    <app-phone-number [formGroup]="editpTicketForm"></app-phone-number>


    <mat-form-field class="input-group">
        <mat-label>User mail</mat-label>
        <input matInput formControlName="pct_useremail" [value]="pTicket.pct_useremail">
    </mat-form-field>
    <mat-form-field class="input-group">
        <mat-label>Response mail</mat-label>
        <input matInput formControlName="pct_responseemail" [value]="pTicket.pct_responseemail">
    </mat-form-field>



    <mat-form-field class="input-group">
        <mat-label>Product</mat-label>
        <mat-select formControlName="pct_product" [value]="pTicket.pct_product">
            <mat-option *ngFor="let product of products" [value]="product.ppd_name">
                {{ product.ppd_name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>